var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"header"},[_c('div',[_c('h3',[_vm._v(_vm._s(_vm.text1))])])]),_c('div',{staticClass:"container"},[_c('img',{staticClass:"content",attrs:{"src":_vm.img1,"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }